// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3kNcS","tag":"Info_tag__3chN8","icons":"Info_icons__3mZ9b"};